import { Component, OnInit } from '@angular/core';
import { loadingFade, modal, alert } from '../../animacoes';
import { NormaService } from '../services/norma.service';
import { AuthService } from '../services/auth.service';
import { environment } from 'src/environments/environment';
import { PerfilUsuarioService } from '../services/perfil-usuario.service';
import { ActivatedRoute, Router } from "@angular/router";

import Swal from 'sweetalert2';

@Component({
  selector: 'app-norma',
  templateUrl: './norma.component.html',
  styleUrls: ['./norma.component.css'],
  animations: [loadingFade]
})
export class NormaComponent implements OnInit {

	public menu_id = 167;
	public loading = false;
	public normas = [];
	public bairro_array = [];

	// paginacao
	public page = 1;
	public limit = 10;
	public count = 0;

	public perfil = this.authSvc.getPerfil();
	  
	public img_extensions = ['png', 'jpg', 'jpeg', 'bmp', 'gif'];

		//acesso
		public usuario_perfil;
		public visualizar = true;
		public editar = false;	
  
	constructor(private normaSvc: NormaService,
				private authSvc : AuthService,
				private router: Router,
				private route: ActivatedRoute,	
				private perfilUsuarioSvc: PerfilUsuarioService) { }

	ngOnInit() {

		//Verifica Permissões Acesso
		this.usuario_perfil = this.authSvc.getPerfil();
		this.perfilUsuarioSvc.getByVerificaPermissao(this.usuario_perfil,this.menu_id).then((data: any[]) => {
		if(data[0].editar){
			this.editar = true;
		}
		}).catch((err) => {
		console.log(err);
		}); 

		this.pegaNormas();
	}

  	primPagina() {
		this.page = 1;
	}

	paginaAnt() {
		this.page = Math.max(this.page - 1, 1);
	}

	proxPagina() {
		this.page = Math.min(this.page + 1, Math.ceil(this.count / this.limit));
	}

	ultPagina() {
		this.page = Math.ceil(this.count / this.limit);
	}

	printMsg(){
		Swal.fire({
			type:'warning',
			title: 'hello World!'
		});
	}

	pegaNormas(){
		this.normas = [];
		this.loading = true;
		this.normaSvc.getNormas().then((data: any[]) => {
			this.normas = data;
			this.count = this.normas.length;
			this.loading = false;
		}).catch((err) => {
			console.log(err);
			this.loading = false;
		})
	}

	apagaNorma(id) {
		Swal.fire({
			type:'warning',
			title: 'Deseja realmente apagar este registro?',
			showCancelButton: true,
			showCloseButton: true,
			confirmButtonText: 'Apagar',
			cancelButtonText: 'Cancelar',
			confirmButtonColor: '#d33'
			  
		}).then((result) => {
			if(result.value == true){
				this.normaSvc.apagaNorma(id).then((data) => {
					this.pegaNormas();
					Swal.fire({
						type: 'success',
						title: 'Apagado com sucesso!'
					});
				}).catch((err) => {
					console.log(err);
					Swal.fire({
						type: 'error',
						title: 'Ops! Algo de errado aconteceu!',
						text: 'Não foi possível apagar este registro, tente novamente mais tarde.'
					});
				});
			}
		})
	}

	openFile(file_name){
		if(file_name == null){
			Swal.fire({
				width: '100%',
				imageUrl: environment.serviceApi + '/downloader/notfound.png',
				imageAlt: 'arquivo'
			});
		}
		let file_ext = file_name.split('.')[1];

		if(this.img_extensions.includes(file_ext)){
			Swal.fire({
				width: '100%',
				imageUrl: environment.serviceApi + '/downloader/' + file_name,
				imageAlt: 'arquivo'
			});
		}
		else{
			Swal.fire({
				html: '<a href="' + environment.serviceApi + '/downloader/' + file_name + '"><i class="fa fa-download" style="font-size: 64px;"></i><br>Baixar</a>',
			});
		}
  }

}
